import FactorsViewPanelPeriodControl from "connected-components/factors-view/components/panel-period-control"
import { DRIFT_DATES_SHAPE } from "../../prop-types"

export default function RiskHeader({ driftDates }) {
  // While a date override is active, the chip branch replaces PeriodDisplay, so the drift-adjustment
  // tooltip is hidden for that duration — acceptable for MVP, not an oversight.
  return <FactorsViewPanelPeriodControl isPerformance={false} driftDates={driftDates} label="Drift Period" />
}

RiskHeader.propTypes = {
  driftDates: DRIFT_DATES_SHAPE,
}
